import { createContext, useContext } from "react";

export type ToastTone = "info" | "ok" | "error";

export const ToastContext = createContext<(text: string, tone?: ToastTone) => void>(
  () => undefined,
);

/** Show a short confirmation or error in the corner. */
export const useToast = () => useContext(ToastContext);
